export const getDefaultStandardCardDesc = () => {
    return {
        gaoDu: '',
        guanFu: '',
        zhuGao: '',
        yePianShu: '',
        buZhengChangYeShu: '',
        genXiZhuangTai: '',
        wanQuDu: '',
        zhongLiang: '',
        huaBaoShu: '',
        gaoDuChaJingGan: '',
        bingChongHai: '',
        tuRangShiDu: '',
        kaiFangDu: '',
        jiXieSunShang: '',
        zhuShu: '',
        huaShu: '',
        zhiTiaoShu: '',
        jieJianGaoDu: '',
        yaShu: '',
        chuDu: '',
        qiuJing: '',
        huaXing: '',
        yeFu: ''
    };
};
